import React from 'react';
import { withTranslation } from 'react-i18next/hooks';

import theme from '../../../../theme';

//import {Table, TableHead, TableBody, TableCell, TableRow} from '@material-ui/core';
import {Paper, Menu, MenuItem, ListItemIcon, ListItemText} from '@material-ui/core';

import { formatDateTime } from '../../../../api/date';

import GetAppIcon from '@material-ui/icons/GetApp'
import PlayArrowIcon from '@material-ui/icons/PlayArrow'
import { getBase64ID, getObjectByID } from '../../../../api/helpers'
import { SortableTable } from '../../../../components/SortableTable'

class ReportMonitoringRecordingsList_ extends React.Component {

    constructor(props){
        super(props);
        this.state = {menuAnchor: null}

        this.tableRef = React.createRef()
    }

    mediaTypeName(media){

        switch(media){

            case 1: return "NoCamera"
            case 33: return "RearCamera"
            case 17: return "FrontCamera"
            case 65: return "UsbCamera"

            default: return media
        }
    }

    handleMenuClick_(itemID){
        this.setState({menuItemID: itemID})
    }

    handleMenuClick(event, itemID){
        this.setState({menuAnchor: event.currentTarget, menuItemID: itemID})
        event.stopPropagation()
    }

    handleMenuClose(){
        this.menuAnchor = null
        this.setState({menuAnchor: null})
        return null
    }

    handleMenuItemClick(action){
        
        const itemID = this.state.menuItemID

        let rows = this.tableRef.current.getSelectedRows()
        console.log('handleMenuItemClick')
        console.log(rows)
        console.log(rows.length)

        const row = getObjectByID(itemID, this.props.reportData.rows, 'euuid')

        this.handleMenuClose()
        this.props.onAction({
            type: action, 
            id: itemID, 
            rows: rows.length>0 ? rows : [row],
            version: getBase64ID()
        })
    }

    render(){
        const {t} = this.props

        const styles = {
            paper: {
              width: '100%',
              overflowX: 'auto',
            },
            head: {
                color: theme.palette.color.dialogTitle,
                backgroundColor: theme.palette.background.dialogTitle,
            }
        }

        /**
         * 
         * dispatcher: "x"
​​​
dt: 1713960584747
​​​
event: 1
​​​
manufacturer: "WLLC"
​​​
model: "Application"
​​​
userName: "Administrator"
         * 
         */

        let contextMenu = (  
            <Menu anchorEl={this.state.menuAnchor} keepMounted
                        open={Boolean(this.state.menuAnchor)} onClose={this.handleMenuClose.bind(this)}>
            {/*}
            <MenuItem onClick={()=>{this.handleMenuItemClick('RESOURCE_PLAY')}}>
                <ListItemIcon color="primary"><PlayArrowIcon/></ListItemIcon> 
                <ListItemText primary={t('Play')} />
            </MenuItem>
            */}
            <MenuItem onClick={()=>{this.handleMenuItemClick('RESOURCE_DOWNLOAD')}}>
                <ListItemIcon><GetAppIcon/></ListItemIcon>
                <ListItemText primary={t('Download')} />
            </MenuItem>
            </Menu>
        )

        let columns = [
            {
                label: t('DateTime'),
                name: 'edt',
                eval: (val)=>{return formatDateTime(val, 'full_date')},
                allowSort: true,
            },
            {
                label: t('Device'),
                name: 'manufacturer',
                eval: (val, row)=>(row.manufacturer + ' ' + row.model),
                allowSort: true,
                sortEval: (val, row)=>(row.manufacturer + ' ' + row.model),
            },
            {
                label: t('Source'),
                name: 'media',
                eval: (val, row)=>(t(this.mediaTypeName(row.media))),
                allowSort: true,
                sortEval: (val, row)=>(t(this.mediaTypeName(row.media))),
            },
            {
                label: t('Duration_s'),
                name: 'duration',
                allowSort: true,
            }
        ]


        return(
            <Paper style={styles.paper}>


                <SortableTable
                    t={t}
                    ref={this.tableRef}
                    rows={this.props.reportData.rows}
                    columns={columns}
                    version={this.props.reportData.version}
                    contextMenu={contextMenu}
                    contextMenuKey="euuid"
                    primaryKey="euuid"
                    onMenuClick={this.handleMenuClick.bind(this)}    
                    checkboxSelection
                />

{/**
                <Table size="small">
                    
                    <TableHead>
                        <TableRow>
                            <TableCell style={styles.head}>{t('DateTime')}</TableCell>
                            <TableCell style={styles.head}>{t('Device')}</TableCell>
                            <TableCell style={styles.head}>{t('Source')}</TableCell>
                            <TableCell style={styles.head}>{t('Duration_s')}</TableCell>
                        </TableRow>
                    </TableHead>
                    
                    <TableBody>
                        {this.props.reportData.rows && this.props.reportData.rows.map((row,index)=>(
                            <TableRow key={index} >
                                <TableCell>
                                    {formatDateTime(row.edt, 'full_date')}
                                </TableCell>
                                <TableCell>
                                    {row.manufacturer} {row.model}
                                </TableCell>
                                <TableCell>
                                    {t(this.mediaTypeName(row.media))}
                                </TableCell>
                                <TableCell>
                                    {row.duration}
                                </TableCell>
                            </TableRow>
                        ))}
                        
                    </TableBody>
                </Table>

                 */}


            </Paper>
        );

    }

}

export const ReportMonitoringRecordingsList = withTranslation()(ReportMonitoringRecordingsList_);